import { Checkbox } from "../components/checkbox/Checkbox";
import { CityState } from "../components/citystate/CityState";
import { List } from "../components/list/List";
import { EdiLocation } from "../components/location/EdiLocation";
import { Location } from "../components/location/Location";
import { Panel } from "../components/panel/Panel";
import { RadioGroup } from "../components/radio/RadioGroup";
import { Splitter } from "../components/splitter/Splitter";
import { StarRating } from "../components/starrating/StarRating";
import { Switch } from "../components/switch/Switch";
import { Tabset } from "../components/tabset/Tabset";
import { Textbox } from "../components/textbox/Textbox";
import { Tree } from "../components/tree/Tree";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";

export type ChangeEventTarget = Checkbox | CityState | EdiLocation | List | Location | Panel | RadioGroup | Splitter |
    StarRating | Switch | Tabset | Textbox | Tree;

export interface ChangeListener extends EventListener<ChangeEvent> {
}

export class ChangeEvent extends Event<ChangeEventTarget> {
    public oldValue: any;
    public newValue: any;

    constructor(target: ChangeEventTarget, oldValue: any, newValue: any, domEvent?: DomEvent) {
        super(target, domEvent);
        this.oldValue = oldValue;
        this.newValue = newValue;
    }

    get userInitiatedChange() {
        return this.domEvent != null;
    }
}
